import Input from '@usas/ui-web/components/inputs/Input';
import ReadOnly from '@usas/ui-web/components/readOnly/ReadOnly';
// import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';
// import LscDropdown from '@usas/ui-web/components/dropdowns/lscDropdown/LscDropdown';
import StatesCombobox from '@usas/ui-web/components/comboboxes/statesCombobox/StatesCombobox';
import AddressValidation from '@usas/ui-web/components/addressValidation/AddressValidation';
import LscDropdown from '@usas/ui-web/components/dropdowns/lscDropdown/LscDropdown';
import SearchMemberWithLscPopup from '@usas/ui-web/components/searches/searchMember/SearchMemberWithLscPopup';
import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import global from '@usas/ui-web/components/GlobalStyle.module.css';
// import YesNoSwitch from '@usas/ui-web/components/yesNoSwitch/YesNoSwitch';

const NewOrganizationRegistrationForm = ({
  state, formState, errorState, organizationTypeState, legalEntityTypeState, onValueTextPairChanged, onFormValueChanged, setFormData }) => (
  <div>
    {/* <form onSubmit={handleSubmit} noValidate> */}
    <div className="row">
      <div className="col-xs-12 col-sm-6 col-md-4">
        {organizationTypeState.areItemsLoaded && organizationTypeState.areItemsLoaded === true &&
          <Dropdown
            label="Organization Type*"
            options={organizationTypeState.items}
            name="organizationTypeId"
            value={formState.organizationTypeId}
            error={errorState.organizationTypeId}
            message={errorState.organizationTypeId}
            areValuesIntegers={true}
            isLoading={organizationTypeState.isArrayLoading}
            onChange={(newValue, newValueLabel) => { onValueTextPairChanged(newValue, 'organizationTypeId', newValueLabel, 'typeName'); }}
          />
        }
      </div>
    </div>
    <div className="row usas-extra-top-margin">
      <div className="col-xs-12 col-sm-6 col-md-4">
        {
          legalEntityTypeState.areItemsLoaded && legalEntityTypeState.areItemsLoaded === true &&
          <Dropdown
            label="Legal Entity Type*"
            options={legalEntityTypeState.items}
            name="legalEntityTypeId"
            value={formState.legalEntityTypeId}
            error={errorState.legalEntityTypeId}
            message={errorState.legalEntityTypeId}
            areValuesIntegers={true}
            isLoading={legalEntityTypeState.isArrayLoading}
            onChange={(newValue, newValueLabel) => { onValueTextPairChanged(newValue, 'legalEntityTypeId', newValueLabel, 'typeName'); }}
          />
        }
      </div>
      <div className="col-xs-12 col-sm-6 col-md-4">
        <Input
          label="Legal Entity Name*"
          name="legalEntityName"
          value={formState.legalEntityName}
          error={errorState.legalEntityName}
          message={errorState.legalEntityName}
          onChange={(value) => { onFormValueChanged('legalEntityName', value) }} />
      </div>
      <div className="col-xs-12 col-sm-6 col-md-4">
        <Input
          label="Legal Entity Tax Id*"
          name="legalEntityTaxId"
          value={formState.legalEntityTaxId}
          error={errorState.legalEntityTaxId}
          message={errorState.legalEntityTaxId}
          onChange={(value) => { onFormValueChanged('legalEntityTaxId', value) }} />
      </div>
    </div>
    <div className="row">
      <div className="col-xs-12 col-sm-6 col-md-4">
        {state.isClubCreated === false ?
          <Input
            label="Organization Name*"
            name="organizationName"
            value={formState.organizationName}
            error={errorState.organizationName}
            message={errorState.organizationName}
            onChange={(value) => { onFormValueChanged('organizationName', value) }} />
          :
          <ReadOnly
            label="Organization Name*"
            name="organizationName"
            value={formState.organizationName} />
        }
      </div>
      <div className="col-xs-12 col-sm-6 col-md-4">
        {state.isClubCreated === false ?
          <Input
            label="Organization Code*"
            name="organizationCode"
            value={formState.organizationCode}
            error={errorState.organizationCode}
            message={errorState.organizationCode}
            onChange={(value) => { onFormValueChanged('organizationCode', value) }} />
          :
          <ReadOnly
            label="Organization Code*"
            name="organizationCode"
            value={formState.organizationCode} />
        }

      </div>
      <div className="col-xs-12 col-sm-6 col-md-4">
        <SearchMemberWithLscPopup
          label="Club Administrator*"
          formState={formState}
          errorState={errorState}
          setFormData={setFormData}
          onFormValueChanged={onFormValueChanged} />
        {errorState.apiError &&
          <p className={global.ErrorMessage}>{errorState.apiError}</p>
        }
        {formState.memberId &&
          <ReadOnly
            label=""
            name="memberId"
            value={formState.staffFirstName + ' ' + formState.staffLastName} />
        }
      </div>
      <div className="col-xs-12 col-sm-6 col-md-4">
        <LscDropdown
          label="LSC*"
          name="lscId"
          value={formState.lscId}
          error={errorState.lscId}
          message={errorState.lscId}
          onChange={(newValue, newValueLabel, e) => { onValueTextPairChanged(newValue, 'lscId', newValueLabel, 'lscName', e); }}
          isCurrent={true}
        />
      </div>
      <div className="col-xs-12 col-sm-6 col-md-4">
        <Input
          label="Primary Mailing Club Address*"
          name="address1"
          value={formState.address1}
          error={errorState.address1}
          message={errorState.address1}
          onChange={(value) => { onFormValueChanged('address1', value) }} />
      </div>
      <div className="col-xs-12 col-sm-6 col-md-4">
        <Input
          label="Address Line 2"
          name="address2"
          value={formState.address2}
          error={errorState.address2}
          message={errorState.address2}
          onChange={(value) => { onFormValueChanged('address2', value) }} />
      </div>
      <div className="col-xs-12 col-sm-6 col-md-4">
        <Input
          label="City*"
          name="city"
          value={formState.city}
          error={errorState.city}
          message={errorState.city}
          onChange={(value) => { onFormValueChanged('city', value) }} />
      </div>
      <div className="col-xs-12 col-sm-6 col-md-4">
        <StatesCombobox
          label="State*"
          name="stateCode"
          valueToMatch={formState.stateName}
          error={errorState.stateCode}
          message={errorState.stateCode}
          isUSA={true}
          onChange={(newValue, newValueLabel, e) => { onValueTextPairChanged(newValue, 'stateCode', newValueLabel, 'stateName', e); }} />
      </div>
      <div className="col-xs-12 col-sm-6 col-md-4">
        <Input
          label="Zip Code*"
          name="postalCode"
          value={formState.postalCode}
          error={errorState.postalCode}
          message={errorState.postalCode}
          onChange={(value) => { onFormValueChanged('postalCode', value) }} />
      </div>
      <AddressValidation formState={formState} setFormData={setFormData} />
    </div>
    <div className="row usas-extra-top-margin">
      <div className="col-xs-12">
        <p>By signing below, I certify that the information given on this form is truthful, accurate, and complete.</p>
      </div>
    </div>
    <div className="row">
      <div className="col-xs-12 col-sm-6 col-md-4">
        <Input
          label="First and Last Name*"
          name="registrationSignature"
          value={formState.registrationSignature}
          error={errorState.registrationSignature}
          message={errorState.registrationSignature}
          onChange={(value) => {
            onFormValueChanged('registrationSignature', value);
            onFormValueChanged('registrationDate', formState.today);
          }} />
      </div>
      <div className="col-xs-12 col-sm-6 col-md-4">
        <ReadOnly
          label="Signature Date"
          name="registrationDate"
          value={formState.registrationDate} />
      </div>
    </div>
    {/* </form> */}
  </div>
)

export default NewOrganizationRegistrationForm;